import React, { useEffect, useState } from "react";
import { Wrapper, Image,Content,StyledLink } from "./Knoppie.styles";
import { Link } from "react-router-dom";




const Knoppie = ({callback,employeeid,text,destination,clickable,dropdown,actionbtn,image,pdffile,from,setTrigger,type,switchOn}) =>{


const [state,setState] = useState(false)

useEffect(()=>{
    

},[])

return(

<Wrapper dropdown={dropdown}>    
        
        {clickable?(
            !actionbtn?
            <StyledLink 
            to={destination}
            state={{pdffile:pdffile,id:employeeid,from:from,type:type}}
            >
                <Content
                onClick={callback}
                id={employeeid}
                pdffile={pdffile}
                switchOn={switchOn}
                dropdown={dropdown}
                >
                {image &&
                <Image src={image}></Image>
                
                }    
                {text}
                
                </Content>
            </StyledLink>
            : <Content
            
            onClick={callback}
            >
             
                {text}
            
            
            </Content>
            
        ):
        (<Content onClick={callback}>{text}</Content>)
        
        }
   
  

</Wrapper>
)

}





export default Knoppie;